import {
    isPhoneNumberE164,
    ReferenceContactId,
    TaskTypeId,
    toPhoneNumberE164,
} from "@sp-crm/core";
import { EntityContactDetails } from "components/details-page-v-next/entity-contact-details";
import { tierColorForToken } from "components/references/show-reference/tier-colors";
import { ReferralParent } from "components/visits/types";
import { AdvancedSearchEntityType } from "generated/graphql";
import React from "react";
import { Link } from "react-router-dom";
import { contactPath } from "./agenda-actions";
import { AgendaRecentActivity } from "./agenda-recent-activity";
import { agendaContactDetails, AgendaContactGroup } from "./marketing-plan-agenda";
import { TouchpointRow } from "./touchpoint-row";

interface AgendaContactCardProps {
    group: AgendaContactGroup;
    hasPhoneLine: boolean;
    onSendEmail: (
        contactId: ReferenceContactId,
        activityTypeId: TaskTypeId | null,
    ) => void;
}

export const AgendaContactCard: React.FC<AgendaContactCardProps> = ({
    group,
    hasPhoneLine,
    onSendEmail,
}) => {
    const color = tierColorForToken(group.tierColor);
    const phone =
        group.contactPhone && isPhoneNumberE164(group.contactPhone)
            ? toPhoneNumberE164(group.contactPhone)
            : null;
    const parent: ReferralParent = {
        kind: "contact",
        id: group.contactId,
        name: group.contactName,
        address: null,
    };

    return (
        <div className="rounded-lg bg-white p-4 ring-1 ring-gray-300 sm:p-5">
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <Link
                        to={contactPath(group.contactId)}
                        className="block truncate font-semibold text-gray-900 hover:underline">
                        {group.contactName}
                    </Link>
                    {group.orgName ? (
                        <div className="mt-0.5 truncate text-sm text-gray-500">
                            {group.orgName}
                        </div>
                    ) : null}
                </div>
                {group.tierName ? (
                    <span
                        className={`inline-flex flex-shrink-0 items-center rounded-full ${color.bg} ${color.text} px-2.5 py-0.5 text-xs font-medium`}>
                        {group.tierName}
                    </span>
                ) : null}
            </div>
            <div className="mt-2">
                <EntityContactDetails
                    entityId={group.contactId}
                    entityType={AdvancedSearchEntityType.ReferenceContact}
                    details={agendaContactDetails(group)}
                />
            </div>
            <div className="mt-3 divide-y divide-gray-100 border-t border-gray-100">
                {group.touchpoints.map(touchpoint => (
                    <TouchpointRow
                        key={touchpoint.touchpointId}
                        touchpoint={touchpoint}
                        parent={parent}
                        email={group.contactEmail}
                        emailOptedOut={group.contactEmailOptedOut}
                        phone={phone}
                        hasPhoneLine={hasPhoneLine}
                        onSendEmail={activityTypeId =>
                            onSendEmail(group.contactId, activityTypeId)
                        }
                    />
                ))}
            </div>
            <AgendaRecentActivity items={group.recentActivity} />
        </div>
    );
};
